import { API_URL_MEDIA } from "@constants/env";
import apiInstance from "@services/Shared/instanceAxios";
import TCreateEditMedia from "types/Media/createEditMedia";

const updateMedia = (uuid: string, editedItem: TCreateEditMedia) =>
  apiInstance({
    url: API_URL_MEDIA + uuid,
    method: "put",
    data: editedItem,
  });

export default updateMedia;
